export const defineCreateClaimantSuccessMessage = (name: string) => `Claimant ${name} has been added successfully`;
